import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IFloorResponse } from "@miplatform/types";

export const useFloors = () => {
  const [floors, setFloors] = useState<IFloorResponse[]>([]);

  const stateManager = useComponentState();

  const getFloors = () => {
    return stateManager.run(async () => {
      const response = await homeService.floors.getAll({
        sort: "displayOrder asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setFloors(response.data);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    floors,
    getFloors,
  };
};
